export const ROLES_COLUMNS = [
  { name: "role", align: "left" },
  { name: "features", align: "center" },
  { name: "users", align: "center" },
  { name: "actions", align: "center" },
];

export const ROLES_MESSAGES = {
  empty: "No roles yet.",
  nameRequired: "Role name is required.",
  featuresRequired: "Select at least one feature.",
  created: "Role created successfully.",
  updated: "Role updated successfully.",
  deleted: "Role deleted successfully.",
  superAdminProtected: "The Super Admin role can't be changed",
  builtInNoDelete: "Built-in roles can't be deleted",
};
